import { Flex } from '@chakra-ui/react';
import { AvatarItem } from './AvatarItem';

export const AvatarList = ({
  avatarList = [] as any,
  showName = true,
  props,
  alignItems = 'center',
  gap = '2px',
  flexDir = 'row' as any,
  size,
  color,
}) => {
  return (
    <Flex gap={gap} alignItems={alignItems} flexDir={flexDir}>
      {avatarList?.map((avatarItr) => {
        return (
          <AvatarItem
            key={avatarItr?.id}
            name={avatarItr?.name}
            src={avatarItr?.avatar || null}
            showName={showName}
            props={props}
            fontSize={size}
            color={color}
          />
        );
      })}
    </Flex>
  );
};
